module.exports = require('./stripHtml')
